"use strict";

function Event(type, bubbles, cancelable, target) {
    this.initEvent(type, bubbles, cancelable, target);
}

Event.prototype = {
    initEvent: function(type, bubbles, cancelable, target) {
        this.type = type;
        this.bubbles = bubbles;
        this.cancelable = cancelable;
        this.target = target;
        this.currentTarget = target;
    },

    // eslint-disable-next-line no-empty-function
    stopPropagation: function() {},

    preventDefault: function() {
        this.defaultPrevented = true;
    }
};

module.exports = Event;
